import { render, staticRenderFns } from "./teacherDetails.vue?vue&type=template&id=68c71243"
import script from "./teacherDetails.vue?vue&type=script&lang=js"
export * from "./teacherDetails.vue?vue&type=script&lang=js"
import style0 from "./teacherDetails.vue?vue&type=style&index=0&id=68c71243&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports